import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loading from 'components/shared-components/Loading';
import { useGetProfileQuery } from 'services/authApi';
import { getAuthenticatedEntryPath } from 'utils/adminAccess';

const PublicRoute = () => {
  const { token, user } = useSelector((state) => state.auth);
  const { data: profile, isLoading } = useGetProfileQuery(undefined, {
    skip: !token,
  });
  const currentUser = user || profile;

  if (token) {
    if (!currentUser && isLoading) {
      return <Loading cover="page" />;
    }
  }

  return token ? (
    <Navigate to={getAuthenticatedEntryPath(currentUser)} />
  ) : (
    <Outlet />
  );
};

export default PublicRoute;
